import type React from "react";
import { ReactComponent as Svg } from "./assets/remove-circle.svg";
import * as styles from "./Icon.module.scss";

type CancelProps = React.SVGProps<SVGSVGElement>;

export const Cancel = ({ className, ...props }: CancelProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
